import {
  DataType as CapabilityDataType,
  Operation as CapabilityOperation,
} from '@weave/schema-gen-ts/dist/schemas/syncapp/integrations-service/capability.pb';
import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { useSchedulingLocationInfo } from './use-scheduling-location-info';

export const useAppointmentTypesCustomizationAndFeatureFlagsHelper = (selectedLocationId: string) => {
  const { getOnlineSchedulingReadyLocationIds } = useSchedulingLocationInfo();

  const isOnlineSchedulingEnabled = getOnlineSchedulingReadyLocationIds().includes(selectedLocationId);

  const {
    hasIntegrationCapability: hasListAppointmentTypesCapability,
    isLoading: isLoadingListAppointmentTypesCapability,
  } = SchedulerV3.Helpers.useCheckIntegrationCapability(
    { type: CapabilityDataType.APPOINTMENT_TYPE, operation: CapabilityOperation.LIST },
    selectedLocationId
  );

  return {
    hasListAppointmentTypesCapability,
    isOnlineSchedulingEnabled,
    isLoading: isLoadingListAppointmentTypesCapability,
  };
};
